const { showError, showNotifikasi } = require('../libs/helper')

module.exports = {
  getDashboard: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-dashboard`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getDashboardMonthly: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-dashboard-month`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getDashboardSummary: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/get-summary-dashboard`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
}
